<template>
  <div class="section section--half-padding">
    <h2 class="title title--3">Select a Favorite Location</h2>
    <location-selector
      :is-selecting="isSelecting"
      :show-store-validations="false"
      :selected-store-id="selectedStoreId"
      inline-search-results
      @select="handleSelectFavoriteStore"
    />
  </div>
</template>

<script>
  import logger from '@/services/logger';

  export default {
    name: 'SelectFavoriteStore',

    props: {
      selectedStoreId: {
        type: Number,
        default: null
      },
      onFavoriteStoreSelection: {
        type: Function,
        required: true
      }
    },

    data: () => ({
      isSelecting: false
    }),

    methods: {
      async handleSelectFavoriteStore(selectedStore) {
        try {
          this.isSelecting = true;
          await this.onFavoriteStoreSelection(selectedStore);
          this.$closeModal('selectFavoriteStore');
        }
        catch (error) {
          logger.error(error);
        }
        finally {
          this.isSelecting = false;
        }
      }
    }
  };
</script>
